export default "__VITE_ASSET__ClmrSqU___"